export default __webpack_public_path__ + "static/media/CrimsonPro-Regular.3a0b3403.ttf";